/* eslint-disable max-len */
import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    Card,
    CardContent
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

const Step7View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const InfoField: React.FC<{ label: string; value: any }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Typography variant="body1">
                {value || 'Não informado'}
            </Typography>
        </Box>
    );

    const StatCard: React.FC<{
        title: string;
        value: string | number | null;
        color: string;
        bgColor: string;
    }> = ({ title, value, color, bgColor }) => (
        <Card variant="outlined" sx={{ backgroundColor: bgColor, height: '100%' }}>
            <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h3" sx={{ color, fontWeight: 'bold', mb: 1 }}>
                    {value || '0'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {title}
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Famílias Atendidas
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="body1" color="textSecondary" gutterBottom sx={{ mb: 3 }}>
                        Informações sobre as famílias de agricultura familiar atendidas pela Secretaria/Órgão Municipal:
                    </Typography>
                </Grid>

                {/* Cards com Estatísticas */}
                <Grid item xs={12} md={4}>
                    <StatCard
                        title="Total de Famílias de Agricultura Familiar"
                        value={formulario.quantidade_familias_agricultura_familiar}
                        color="#1976d2"
                        bgColor="#e3f2fd"
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <StatCard
                        title="Famílias Beneficiadas Total"
                        value={formulario.quantidade_familias_agricultura_familiar_beneficiadas_total}
                        color="#2e7d32"
                        bgColor="#e8f5e8"
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <StatCard
                        title="Famílias Quilombolas Beneficiadas"
                        value={formulario.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas}
                        color="#ed6c02"
                        bgColor="#fff3e0"
                    />
                </Grid>

                {/* Informações Detalhadas */}
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 3, mt: 2, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                            Detalhamento das Informações
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <InfoField
                                    label="Quantidade de Famílias de Agricultura Familiar no Município"
                                    value={formulario.quantidade_familias_agricultura_familiar}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InfoField
                                    label="Quantidade de Famílias Beneficiadas (Total)"
                                    value={formulario.quantidade_familias_agricultura_familiar_beneficiadas_total}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InfoField
                                    label="Quantidade de Famílias Quilombolas Beneficiadas"
                                    value={formulario.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                {/* Análise dos Dados */}
                {(formulario.quantidade_familias_agricultura_familiar ||
                    formulario.quantidade_familias_agricultura_familiar_beneficiadas_total) && (
                        <Grid item xs={12}>
                            <Paper variant="outlined" sx={{ p: 3, backgroundColor: '#e8f5e8' }}>
                                <Typography variant="h6" gutterBottom sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
                                    Análise de Cobertura
                                </Typography>

                                {formulario.quantidade_familias_agricultura_familiar &&
                                    formulario.quantidade_familias_agricultura_familiar_beneficiadas_total && (
                                        <Box>
                                            <Typography variant="body1" gutterBottom>
                                                <strong>Taxa de Cobertura:</strong> {' '}
                                                {(
                                                    (formulario.quantidade_familias_agricultura_familiar_beneficiadas_total /
                                                        formulario.quantidade_familias_agricultura_familiar) * 100
                                                ).toFixed(1)}% das famílias de agricultura familiar são beneficiadas pelos programas da secretaria.
                                            </Typography>
                                        </Box>
                                    )}

                                {formulario.quantidade_familias_agricultura_familiar_beneficiadas_total &&
                                    formulario.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas && (
                                        <Typography variant="body1">
                                            <strong>Inclusão Quilombola:</strong> {' '}
                                            {(
                                                (formulario.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas /
                                                    formulario.quantidade_familias_agricultura_familiar_beneficiadas_total) * 100
                                            ).toFixed(1)}% das famílias beneficiadas são quilombolas.
                                        </Typography>
                                    )}
                            </Paper>
                        </Grid>
                    )}
            </Grid>
        </Paper>
    );
};

export default Step7View; 